import type { CoachProfile } from '@efdigital/ll-addon-data';
import { queryCoachProfilesByUserIds } from '@efdigital/ll-xceed-v2/data/builders/coaching/coach-profiles';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortSessionsModel } from '../sessions';

export type CoachingCoacheeCohortSessionsActionRequiredModel =
  CoachingCoacheeCohortSessionsModel & {
    coaches: CoachProfile[];
  };

export default class CoachingCoacheeCohortSessionsActionRequiredRoute extends Route<CoachingCoacheeCohortSessionsActionRequiredModel> {
  @service declare store: Store;

  async model(): Promise<CoachingCoacheeCohortSessionsActionRequiredModel> {
    const sessionsModel = this.modelFor(
      'coaching.coachee.cohort.sessions'
    ) as CoachingCoacheeCohortSessionsModel;

    // Only the action-required sessions are rendered here — pending-confirmation
    // ones live under Upcoming — so only their coaches need resolving.
    const coachUserIds = Array.from(
      new Set(
        sessionsModel.actionRequired.map((session) => session.coachUserId)
      )
    );
    const coaches = await this.store.request(
      queryCoachProfilesByUserIds(coachUserIds)
    );

    return {
      ...sessionsModel,
      coaches: coaches.content.data,
    };
  }
}
